<template>
  <div
    class="answer-modal"
    id="answer-modal"
    :style="[isZoomed() ? { 'align-items': 'flex-start' } : { 'align-items': 'center' }]"
  >
    <!-- @keyup.esc="handleEsc()" -->
    <div class="imgBox" v-if="croppImage" :style="croppImage.zoom ? smallImg.true : smallImg.false">
      <cropp-image :img-config="croppImage"> </cropp-image>
    </div>
    <div class="imgBox" id="answer-image" v-if="!croppImage" :style="imgSrc.zoom ? smallImg.true : smallImg.false">
      <img
        @load="loadImg($event)"
        id="img-answer"
        class="answer-image"
        :src="src"
        :style="imgSrc.zoom ? {} : { cursor: 'auto' }"
        @mousemove.self="onMouseMove($event)"
        @mouseenter="zoomShow = true"
        @mouseleave="zoomShow = false"
      />
      <!-- <div
        style="position: fixed;"
        :style="{
          background: 'rgba(255,255,255,.5)',
          width: size * 2 + 'px',
          height: size * 2 + 'px',
          top: top.zoom + 'px',
          left: left.zoom + 'px',
        }"
      ></div> -->
      <div
        @mouseenter="changePosition = !changePosition"
        v-if="imgSrc.zoom"
        style="position: fixed; background-repeat: no-repeat"
        :style="[
          {
            width: size * 2 + 'px',
            height: size * 2 + 'px',
            top: (1080 - size * 2) / 2 + 'px',
            transform: 'scale(' + zoom + ')',
            right: (1920 / 2 - size * 2) / 2 + 'px',
            'transform-origin': 'center center',
          },
        ]"
      >
        <img
          class="zoomed-image"
          :src="src"
          id="zoomed-answer-img"
          :style="[
            {
              'object-position': left.main + '% ' + top.main + '%',
              width: size * 2 + 'px',
              height: size * 2 + 'px',
            },
          ]"
        />
      </div>
    </div>
    <button type="close" title="Zamknij ćwiczenie" name="close" @click="handleOk()" class="close-button">
      <svg fill="#ffffff" height="55" viewBox="0 0 24 24" width="55">
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          fill="rgb(230, 230, 230)"
        />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </button>
  </div>
</template>
<script>
import $ from 'jquery';
import CroppImage from '__mainSrcDir/components/CroppImage/CroppImage';
export default {
  name: 'answer-modal',
  components: { CroppImage },
  props: {
    imgSrc: {
      type: Object,
      default: function () {
        return {};
      },
    },
    croppImage: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      smallImg: {
        x: 0,
        y: 0,
        true: { 'max-width': '50%', 'max-height': '50%', marginLeft: '0px' },
        false: {
          'max-width': '90%',
          'max-height': '96%',
          'align-items': 'center',
        },
      },
      bcgSize: {
        x: 1920,
        y: 1080,
      },
      left: {
        main: 0,
        zoom: 0,
      },
      top: {
        main: 0,
        zoom: 0,
      },
      src: null,
      size: 100,
      zoom: 3,
      zoomShow: false,
      changePosition: false,
    };
  },
  methods: {
    isZoomed() {
      if (this.croppImage) {
        if (this.croppImage.zoom) {
          return true;
        } else {
          return false;
        }
      } else if (this.imgSrc.zoom) {
        return true;
      } else {
        return false;
      }
    },
    init() {
      if (this.imgSrc.src) {
        this.src = this.giveMeImagePlease(this.imgSrc.src);
      }
      if (this.croppImage) {
        console.log((960 - this.croppImage.cropp.width) / 2 + 'px');
        this.smallImg.true.marginLeft = (960 - this.croppImage.cropp.width) / 2 + 'px';
      }
    },
    loadImg(e) {
      this.bcgSize.x = e.target.clientWidth;
      this.bcgSize.y = e.target.clientHeight;
      this.smallImg.true.marginLeft = (960 - e.target.clientWidth) / 2 + 'px';
    },
    onMouseMove(e) {
      let $innerWindow = $('.game-scaleable-wrapper');
      let $el = $('#answer-modal');
      let el = document.getElementById('answer-modal');
      let elHeight = $el.outerHeight();
      let elWidth = $el.outerWidth();
      let scale;
      scale = Math.min($innerWindow.width() / elWidth, $innerWindow.height() / elHeight);
      let img = $('#zoomed-answer-img').outerWidth();
      this.left.main =
        ((e.pageX - ($innerWindow.width() - $el.width() * scale) / 2 - e.target.offsetLeft * scale) /
          (e.target.width * scale)) *
        100;
      this.top.main =
        ((e.pageY - ($innerWindow.height() - $el.height() * scale) / 2 - e.target.offsetTop * scale) /
          (e.target.height * scale)) *
        100;
    },
    giveMeImagePlease(path) {
      console.log(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    handleOk() {
      return this.$emit('modal-off');
    },
    handleEsc() {},
  },
  computed: {},
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
.answer-modal
  width: 100%
  height: 100%
  position: fixed
  z-index: 99999
  top: 0
  display: flex
  justify-content: center
  align-items: flex-start
  flex-direction: column
  background: rgba(0,0,0,.3)
  .imgBox
    max-width: 50%
    max-height: 100%
    // padding: 1%
    border-radius: .5em
    background: transparent
    .answer-image
      max-width: 100%
      max-height: 100%
      cursor: zoom-in
    .answer-title
      padding: 0
      margin: 0
  .close-button
    pointer-events: auto
    position: absolute
    top: 0
    right: 0
    opacity: 1
    z-index: 1003
    cursor: pointer
    outline: none
    border: none
    background-color: $backgroundControlPanelColor
    margin-right: 12px
    margin-top: 22px
    border-radius: 50%
    display: flex
    transform: scale(1)
    padding: 0
    svg
      path:first-child
        fill: $bacgroundColor
        transition: all 0.4s ease
    &:hover
      svg
        path:first-child
          fill: $closeActiveColor
          transition: all 0.4s ease
      transition: all 0.4s ease
    img
      width: 100%
      height: 100%
.zoomed-image
  object-fit: none
  padding: 0
.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  transform: scale(2,2)
  opacity: 0
</style>
